export class BundlesBox extends HTMLElement {
    constructor() {
        super()
        this.config = {
            transform: this.dataset.transform ? true : false,
            offsetX: +0,
            offsetY: -0,
            row1: this.querySelector("#row-1"),
        }
        this.productData = JSON.parse(
            this.closest("build-yourown").querySelector(".productsData")
                .innerText
        )
        this.productImageUrlsObject = JSON.parse(
            this.closest("build-yourown").querySelector("#productUrls")
                .innerText
        )

        this.refreshProductImageUrls()

        this.selectors = {
            buildYourOwn: "build-yourown",
        }

        this.elements = {
            buildYourOwn: this.closest(this.selectors.buildYourOwn),
        }
    }

    static observedAttributes = ["data-box-size", "data-render"]

    attributeChangedCallback(name, oldValue, newValue) {
        if (!newValue) return
        if (name === "data-box-size") {
            this.onSizeChange.call(this, [oldValue, newValue])
        }
        if (name === "data-render" && newValue === "true") {
            this.reRender()
            this.dataset.render = false
        }
    }

    onSizeChange(oldVal, newVal) {
        if (!oldVal) oldVal = 0
        if (oldVal == newVal) return
        this.reRender()
    }

    getUrlArrData() {
        const buildYourOwnForm = this.closest("build-yourown")
        const _itemdat = JSON.parse(
            buildYourOwnForm.dataset["bundle_products"]
        ).items
        const itemdata = Object.values(_itemdat).filter(
            (obj) => obj.quantity !== 0
        )
        let urlArr = itemdata?.map((_obj) => {
            const _q = parseInt(`${_obj.quantity}`),
                _id = _obj.id
            const _prod = this.productData.filter(
                (prod) => `${prod.variants[0].id}` === `${_id}`
            )[0]
            const _src = this.getSRC(_prod)
            return Array(_q).fill({ id: _id, src: _src })
        })
        urlArr = urlArr.flat()
        return urlArr
    }

    refreshProductImageUrls() {
        this.productImageUrls = Object.fromEntries(
            this.productImageUrlsObject[
                this.closest("build-yourown").dataset.variantId
            ]
        )
    }
    getSRC(productObj) {
        // console.log(productObj, this.productImageUrls)
        return this.productImageUrls[productObj.id]
    }

    cleanBoxes() {
        const _boxes = Array.from(this.querySelectorAll("bundles-box--item"))
        if (_boxes.length > 0) {
            _boxes.forEach((box) => {
                box.remove()
            })
        }
    }

    makeBoxes() {
        const packSize = parseInt(this.elements.buildYourOwn.dataset.boxSize)
        const templateBox = this.querySelector("#boxItem")
        let _z = 10
        const comp = this
        for (let i = 0; i < packSize; i++) {
            const _offx = comp.config.offsetX,
                _offy = this.config.offsetY
            const clone = templateBox.content.cloneNode(true)
            const boxItemNode = clone.querySelector("bundles-box--item")
            const mainNode = clone.querySelector(".main")
            if (this.config.transform) {
                if (i)
                    boxItemNode.style.transform = `translate(${i * _offx}%,${i * _offy}%)`
            }

            boxItemNode.style["z-index"] = `${_z}`
            const numNode = boxItemNode.querySelector("[data-box-number]")
            if (numNode) numNode.textContent = i + 1

            // // // console.log(i)
            if (i < 6) {
                // console.log(this.querySelector("#row-1"))
                this.querySelector("#row-1").appendChild(clone)
            } else if (i < 12) {
                this.querySelector("#row-2").appendChild(clone)
            } else if (i < 18 && i >= 12) {
                this.querySelector("#row-3").appendChild(clone)
            } else if (i < 24 && i >= 18) {
                this.querySelector("#row-4").appendChild(clone)
            }
            _z--
        }
    }
    resetHeight() {
        const rowHeight = this.querySelector(
            "#desktop-boxes #row-1"
        )?.clientHeight
        const rowHeightMobile = this.querySelector(
            "#mobile-boxes #row-1"
        )?.clientHeight
        if (rowHeight) {
            this.elements.buildYourOwn.style.setProperty(
                "--boxes-container-height",
                `${rowHeight}px`
            )
        }
        if (rowHeightMobile) {
            this.elements.buildYourOwn.style.setProperty(
                "--boxes-container-height-mobile",
                `${rowHeightMobile}px`
            )
        }
    }
    reRender() {
        this.form_data = this.closest("build-yourown").dataset.form
        this.refreshProductImageUrls()
        /*
        console.log(
            this.dataset,
            this.form_data,
            this.closest("build-yourown").dataset.form
        )
        */

        this.cleanBoxes()
        this.makeBoxes()
        this.updateLabels()
        const urlArr = this.getUrlArrData()
        const boxes = []

        for (let i = 1; i <= 4; i++) {
            boxes.push(
                ...Array.from(
                    this.querySelector(`#row-${i}`).querySelectorAll(
                        "bundles-box--item"
                    )
                )
            )
        }
        boxes.forEach((box, _i) => {
            const imgNode = box.querySelector("img")
            const removeButton = box.querySelector(".remove")
            //// console.log(imgNode)
            if (urlArr[_i]) {
                imgNode.src = urlArr[_i].src
                const corresNode = this.closest("build-yourown").querySelector(
                    `#size-specific-boxes[data-variant-id="${this.elements.buildYourOwn.dataset.variantId}"] box-item[data-id="${urlArr[_i].id}"]`
                )
                const removeFunc = corresNode.removeOne.bind(corresNode)
                removeButton.addEventListener("click", (e) => {
                    e.preventDefault()
                    removeFunc()
                })
                removeButton.classList.remove("hidden")
            }
        })
        this.form_data = this.closest("build-yourown").dataset.form

        this.resetHeight()
    }

    updateLabels() {
        this.elements.buildYourOwn
            .querySelectorAll("[data-pack-size]")
            .forEach((node) => {
                node.textContent = this.elements.buildYourOwn.dataset.boxSize
            })

        this.elements.buildYourOwn
            .querySelectorAll("[data-current-filled]")
            .forEach((node) => {
                node.textContent = this.getUrlArrData().length
            })

        this.elements.buildYourOwn
            .querySelectorAll("[data-current-left]")
            .forEach((node) => {
                node.textContent =
                    parseInt(this.elements.buildYourOwn.dataset.boxSize) -
                    parseInt(this.getUrlArrData().length)
            })
    }
}
customElements.whenDefined("build-yourown").then(() => {
    customElements.define("bundles-box", BundlesBox)
})
